export default __webpack_public_path__ + "static/media/dd.fb003617.png";